module.exports = __webpack_public_path__ + "media/img/features/dark-theme-b32ca98e02ae06ac28302ff1b5791f9b.gif";